// @flow
import $ from 'jquery';
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import dayjs from 'dayjs';
import { color } from '../../../../admin/styles/theme';

export default class FormView extends JQueryView {
  numerics: Array<any>;
  establishAt: string;
  isFirstRound: boolean;
  form: any;

  constructor(establishAt: string, isFirstRound: boolean) {
    super('[data-form="new_capital_event_round"]');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.form = $('[data-form="new_capital_event_round"]');
    this.isFirstRound = isFirstRound;
    this.establishAt = establishAt;
    this.initDateRangePicker(this.$el);
    this.renderDisabledColor();
    this.toggleRoundFormInput(
      this.form.find('#company_capital_event_round_round_type').val(),
    );

    const stockPrice = Number(
      this.form.find('#company_capital_event_round_stock_price').val(),
    );
    if (stockPrice > 0) {
      this.form
        .find('#company_capital_event_round_stock_price')
        .val(stockPrice.toLocaleString());
    }
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        minDate: this.establishAt,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur input', selector: '.form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  @on({ event: 'click' })
  onClickOtherArea(event: any) {
    if (!$(event.target).closest('.date-field').length) {
      $('.date-field').removeClass('focus');

      if ($('.date-field').val().length === 0) {
        $('.date-field').removeClass('form-control-active');
      }
    }
  }

  @on({
    event: 'blur input',
    selector: '#company_capital_event_round_stock_price',
  })
  onInputForm(event: any) {
    const target = $(event.target);
    const inputVal = Number(target.val().replace(/,|[^0-9\-]+/g, '')); // eslint-disable-line no-useless-escape
    if (inputVal > 0) {
      target.val(inputVal.toLocaleString());
    }
  }

  @on({ event: 'change', selector: '#company_capital_event_round_round_type' })
  onChangeRoundType(event: any) {
    const target = $(event.target);
    this.toggleRoundFormInput(target.val());
  }

  toggleRoundFormInput(roundType: string) {
    const stockTypeInputDiv = this.form.find(
      '.form-group.company_capital_event_round_stock_type',
    );
    const rightTypeInputDiv = this.form.find(
      '.form-group.company_capital_event_round_right_type',
    );

    const stockPriceInputDiv = this.form.find(
      '.form-group.company_capital_event_round_stock_price',
    );

    if (roundType === 'stock' || !roundType) {
      rightTypeInputDiv.hide();
      rightTypeInputDiv.find('select').prop('disabled', true);
      stockTypeInputDiv.show();
      stockTypeInputDiv.find('select').prop('disabled', false);
      if (this.isFirstRound) {
        stockTypeInputDiv.find('select').prop('disabled', true);
      }
      stockPriceInputDiv.show();
      stockPriceInputDiv.find('input').prop('disabled', false);
    }

    if (roundType === 'right') {
      rightTypeInputDiv.show();
      rightTypeInputDiv.find('select').prop('disabled', false);
      stockTypeInputDiv.hide();
      stockTypeInputDiv.find('select').prop('disabled', true);
      stockPriceInputDiv.hide();
      stockPriceInputDiv.find('input').prop('disabled', true);
    }
  }

  renderDisabledColor() {
    // disabledの時、透過の影響で背景色が灰色にならない。
    // disabledの時のみ親要素の背景色を変えて対応
    const $dateField = this.form.find('#company_capital_event_round_close_on');
    if ($dateField.is(':disabled')) {
      $dateField
        .parent('div.input-group')
        .css('background-color', color.supplementaryLineGray);
    }
  }
}
